import React from 'react';
import './CTASection.css';

const CTASection = ({
  title,
  description,
  variant = 'primary',
  primaryButtonText = 'Get Started',
  secondaryButtonText = 'Learn More'
}) => {
  return (
    <section className={`cta-section cta-${variant}`}>
      <div className="cta-section-container">
        <div className="cta-content">
          <h2 className="cta-title">{title}</h2>
          {description && <p className="cta-description">{description}</p>}
          <div className="cta-buttons">
            <button type="button" className="cta-btn cta-btn-primary">{primaryButtonText}</button>
            <button type="button" className="cta-btn cta-btn-secondary">{secondaryButtonText}</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
